import { render, staticRenderFns } from "./Section12.vue?vue&type=template&id=249e43a3&"
import script from "./Section12.vue?vue&type=script&lang=js&"
export * from "./Section12.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports